<div class="am-flex-align gap-m tablet-hide">
  <span class="am-flex-center font-icon hover-active-blue icon-bars sidebartoggler pl-m pr-l"></span>
  <div class="am-flex hover-active width-140" (click)="openHomePage()">
    <img class="width-max-full" src="assets/images/tempton-logo-blue.png" alt="homepage" />
  </div>
</div>

<div class="am-flex-align am-flex-mobile-column" [class.gap-s]="!mobile">
  @for (app of apps; track app; let i = $index) {
    <div class="am-flex-center gap-s" (click)="openApplication(app)"
        [ngClass]="{'bb-blue-3':                  appIsActive(app),
                    'bb-grey-mobile':            !appIsActive(app) && (!mobile || mobile && i !== apps.length-1),
                    'events-none':                app.disabled,
                    'bl-grey-mobile':            !mobile && !!i,
                    'p-s   height-50 width-full': mobile,
                    'p-xxs height-55 width-150': !mobile }">
      <div class="am-flex-column am-flex-align am-flex-mobile-row am-flex-mobile-justify gap-m-mobile color-blue text-center hover-active"
          [class.color-grey-mobile]="!appIsActive(app)"
          [class.color-disabled]="app.disabled">
        <span>{{ app.title }}</span>
        <span class="text-s word-no-wrap">{{ app.subtitle }}</span>
      </div>
      @if (app.new) { <span class="color-orange font-s">Neu !</span> }
    </div>
  }
</div>
